import { useState, useCallback } from "react";
import { getAllUnitHolders } from "../stores/services/unit-holder.service";
import { toast } from "react-toastify";

export const useUnitHolderSearch = (
  email: string,
  options?: { unitholder_Type?: string },
) => {
  const [unitholderOptions, setUnitholderOptions] = useState<any[]>([]);
  const [unitholderLoading, setUnitholderLoading] = useState(false);
  const { unitholder_Type = "" } = options || {};

  const fetchInitialUnitholders = useCallback(async () => {
    try {
      setUnitholderLoading(true);
      const response = await getAllUnitHolders(email, "1", "100", {
        type: unitholder_Type,
      });

      if (response.data.status === 200) {
        const options = response.data.data.map((uh: any) => {
          return {
            value: uh?.folio_no,
            label: `${uh?.folio_no} - ${uh?.name}`,
            unitholder_name: uh?.name,
            ...uh,
          };
        });
        setUnitholderOptions(options);
      } else {
        setUnitholderOptions([]);
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to load unitholders");
      setUnitholderOptions([]);
    } finally {
      setUnitholderLoading(false);
    }
  }, [email]);

  const searchUnitholders = useCallback(
    async (searchValue: string) => {
      if (!searchValue || searchValue.length < 2) {
        await fetchInitialUnitholders();
        return;
      }

      try {
        setUnitholderLoading(true);
        const response = await getAllUnitHolders(email, "1", "10", {
          search_value: searchValue,
          type: unitholder_Type,
        });

        if (response.data.status === 200) {
          const options = response.data.data?.map((uh: any) => ({
            value: uh?.folio_no,
            label: `${uh?.folio_no} - ${uh?.name}`,
            unitholder_name: uh?.name,
            folio_no: uh?.folio_no,
            account_title: uh?.account_title,
            account_no: uh?.account_no,
            bank_name: uh?.bank_name,
            branch_name: uh?.branch_name,
            unitholder_Type: uh.unitholder_Type,
            systematic_investment: uh?.systematic_investment || {},
            ...uh,
          }));
          setUnitholderOptions(options);
        } else {
          setUnitholderOptions([]);
        }
      } catch (err: any) {
        toast.error(
          err?.response?.data?.message || "Failed to search unitholders",
        );
      } finally {
        setUnitholderLoading(false);
      }
    },
    [email, fetchInitialUnitholders],
  );

  return {
    unitholderOptions,
    unitholderLoading,
    fetchInitialUnitholders,
    searchUnitholders,
  };
};
